import * as R from 'ramda'

import schema from '../schema.js'

const viewSchema = R.assocPath(
  ['contents', 'order', 'contents', 'id'],
  schema.header,
  schema.item,
)

export default viewSchema
